module.exports = __webpack_public_path__ + "static/media/44_tn.bceecc15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/style/img/monuments/brownandgray/thumbnails/44_tn.jpg
// module id = 353
// module chunks = 0